import ActionButton from '@/common/components/buttons/ActionButton';
import { getCronDescription } from '@/common/functions/cronTransformer';
import { getOrdersToMailByQuery } from '../../../API/repositories/mail';
import {
	createMailCategory,
	getMailCategories,
	updateMailCategory,
} from '../../../API/repositories/mailCategory';
import { getMailTemplates } from '../../../API/repositories/mailTemplate';
import { getMarkets } from '../../../API/repositories/market';
import { getProducts } from '../../../API/repositories/product';
import { Colors } from '../../../common/colors/colors';
import Input from '../../../common/components/Input';
import Loading from '../../../common/components/Loading';
import { ButtonCreateWrapper, Wrapper } from '../../../common/styles/Mails';
import MailTemplateElement from './components/mailTemplateElement/MailTemplateElement';
import useEmailCategory from './useEmailCategory';
import Icon from '@/common/components/Icon';

const MailCategory = () => {
	const {
		hasUnfilledRequest,
		isRestricted,
		setElement,
		handleChangeRegex,
		element,
		handleLoadData,
		mailTemplateOptions,
		data,
		filterRegex,
	} = useEmailCategory();

	const getIconByBool = (bool) => {
		if (!!bool) {
			return <Icon name='check' color='green' />;
		}

		return <Icon name='x' color='red' />;
	};

	return (
		<>
			{hasUnfilledRequest(
				createMailCategory,
				updateMailCategory,
				getMailCategories,
				getProducts,
				getMarkets,
				getOrdersToMailByQuery,
				getMailTemplates,
			) && <Loading />}
			<Wrapper>
				<ButtonCreateWrapper>
					{!isRestricted && (
						<ActionButton onClick={() => setElement({})} defaultText='Create' />
					)}
					<Input
						width={100}
						inputWidth={200}
						onChange={(e) => handleChangeRegex(e)}
						name='Includer'
						color={Colors.darkBlue}
					/>
				</ButtonCreateWrapper>
				{element && (
					<MailTemplateElement
						element={element}
						setElement={setElement}
						reload={handleLoadData}
						templates={mailTemplateOptions}
					/>
				)}
				<table className='styled-table'>
					<thead>
						<tr>
							<th colSpan={6}>Mail Categories</th>
						</tr>
						<tr>
							<th>No.</th>
							<th>Name</th>
							<th>Cron</th>
							<th>Active</th>
							<th>Send once</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody className='queue'>
						{data[0] && mailTemplateOptions[0] ? (
							data
								.filter((e) =>
									filterRegex ? e.name.includes(filterRegex) : true,
								)
								.map((element, i) => (
									<tr key={element._id}>
										<td>{i + 1}.</td>
										<td>{element.name}</td>
										<td>{getCronDescription(element.cron_time)}</td>
										<td>{getIconByBool(element.active)}</td>
										<td>{getIconByBool(element.should_send_mail_once)}</td>
										<td>
											{!isRestricted && (
												<Icon name='edit' onClick={() => setElement(element)} />
											)}
										</td>
									</tr>
								))
						) : (
							<tr>
								<td colSpan={6}>There is no data</td>
							</tr>
						)}
					</tbody>
				</table>
			</Wrapper>
		</>
	);
};

export default MailCategory;
